import React, { useState } from 'react';
import './Login.scss';

interface LoginProps {
  onLogin: (token: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: 'admin@gidas.lt',
    password: 'admin123'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Make actual API call to authenticate admin
      const response = await fetch(`/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Prisijungimo klaida');
      }

      const data = await response.json();
      
      if (data.success && data.data.user.user_type === 'admin') {
        localStorage.setItem('admin_token', data.data.token);
        localStorage.setItem('admin_user', JSON.stringify(data.data.user));
        onLogin(data.data.token);
      } else if (data.success && data.data.user.user_type !== 'admin') {
        setError('Neturite administratoriaus teisių');
      } else {
        setError(data.message || 'Neteisingas el. paštas arba slaptažodis');
      }
    } catch (err: any) {
      console.error('Login error:', err);
      setError(err.message || 'Prisijungimo klaida. Bandykite dar kartą.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="logo">
            <img src="/logo.png" alt="Gidas.lt" />
          </div>
          <h1>Gidas.lt Admin</h1>
          <p>Prisijunkite prie administratoriaus skydelio</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label>El. paštas</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="admin@gidas.lt"
            />
          </div>

          <div className="form-group">
            <label>Slaptažodis</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              placeholder="Įveskite slaptažodį"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="login-btn"
          >
            {loading ? 'Prisijungiama...' : 'Prisijungti'}
          </button>

          <div className="login-help">
            <p><strong>Demo prisijungimo duomenys:</strong></p>
            <p>El. paštas: admin@gidas.lt</p>
            <p>Slaptažodis: admin123</p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
